<template>
  <div class="layout" id="layout">
    <el-container class="container1">
      <el-header ref="header">
        <headerCon></headerCon>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer id="footer" style="padding:0;">
        <footerCon></footerCon>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import headerCon from "@/components/header";
import footerCon from "@/components/footer";
export default {
  components: {
    headerCon,
    footerCon
  },
  data () {
    return {
      menu: [],
      isRouterAlive: true,
      windowH: 0,
      scrollH: 0,
      oldScrollTop: 0
    };
  },
  watch: {
    '$route': function (to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  methods: {
    handleScroll () {
      // 滚动条距文档顶部的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      if (scrollTop == 0) {
        $(".el-header").removeClass("scrollHeader");
      } else {
        if (scrollStep < 0) {
          $(".el-header").addClass("scrollHeader");
          //console.log("滚动条向上滚动了！");
        } else {
          $(".el-header").removeClass("scrollHeader");
          //console.log("滚动条向下滚动了！");
        }
      }
      // if ($(window).scrollTop() > this.windowH) {
      //   $(".navAside").fadeIn(800);
      // } else {
      //   $(".navAside").fadeOut(800);
      // }
      // var _that = this;
      // _that.scrollH = $(window).scrollTop() + _that.windowH;
      // var footerH = document.getElementById("footer").clientHeight;
      // var footerTop = document.getElementById("footer").offsetTop;
      // if (Number(_that.scrollH) > footerTop) {
      //   $('.navAside').css({ "bottom": (footerH + 20) + "px", "position": "absolute" });
      // } else {
      //   $('.navAside').css({ "bottom": "10px", "position": "fixed" });
      // }
    },
    goBack () {
      $('body,html').animate({ scrollTop: 0 }, 100);
    }
  },
  created () {
    this.windowH = document.documentElement.clientHeight;
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  }
};
</script>


// WEBPACK FOOTER //
// src/page/main.vue